<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <br />
          <form role="form" @submit.prevent="login">
            <div class="row mt--3">
              <div class="col">
                <base-input label="Account Name">
                  <a-input
                    placeholder="Account Name"
                    v-model="formData.accountname"
                  />
                  <div
                    v-if="$v.formData.accountname.$dirty"
                    class="text-danger"
                  >
                    <div class="error" v-if="!$v.formData.accountname.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>

            <div class="row mt--3">
              <div class="col">
                <base-input label="Username">
                  <a-input
                    placeholder="Username/Email"
                    v-model="formData.username"
                  />
                  <div v-if="$v.formData.username.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.username.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>

            <div class="row mt--3">
              <div class="col">
                <base-input label="Password">
                  <a-input-password
                    placeholder="Password"
                    v-model="formData.password"
                  />
                  <div v-if="$v.formData.password.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.password.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>

            <div class="text-center">
              <base-button
                type="primary"
                class="my-4"
                nativeType="submit"
                :disabled="formSubmitting"
                style="width: 50%"
              >
                <a-spin v-if="formSubmitting" :spinning="formSubmitting" />
                <div v-else>Sign in</div>
              </base-button>
              <br />
              <router-link
                to="/admin/bxi-login"
                tag="button"
                class="btn btn-link"
              >
                <small>Login via BXI Credentials</small>
              </router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import secureStorage from '../controllers/secureStorage';
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';

const PromotionAPI = process.env.VUE_APP_PROMOTION_API;

export default {
  name: 'Login',
  data() {
    return {
      formData: {
        username: '',
        password: '',
        accountname: ''
      },
      formSubmitting: false
    };
  },

  validations: {
    formData: {
      username: { required },
      password: { required },
      accountname: { required }
    }
  },
  created() {
    // secureStorage.clear();
    // console.log('Clear Storage');

    console.log('VUE_APP_PROMOTION_API: ', process.env.VUE_APP_PROMOTION_API);
  },
  methods: {
    login: async function () {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        // TODO: Front-end validation

        try {
          const response = await axios({
            method: 'POST',
            url: '/api/auth/login',
            data: { user: this.formData }
          });
          if (response.data.access_token) {
            this.$notification.success({
              message: 'Success'
            });
            secureStorage.clear();
            console.log('Clear Storage');

            secureStorage.setItem(
              'bxiClpAccessToken',
              response.data.access_token
            );

            this.promotionLogin();

            secureStorage.setItem('source', 'clp');

            setTimeout(() => {
              this.$router.push({ name: 'Dashboard' });
            }, 1000);
          }
        } catch (e) {
          const { message: errorMessage } = e.response.data;
          let message = 'Something went wrong. Please try again.';
          if (errorMessage) message = errorMessage;
          this.$notification.error({
            message
          });
        }

        this.formSubmitting = false;
      }
    },

    promotionLogin: async function () {
      try {
        const response = await axios({
          method: 'POST',
          url: PromotionAPI + '/auth/login',
          data: { user: this.formData }
        });
        if (response.data.access_token) {
          console.log('Set promotion token');
          secureStorage.setItem('promotionToken', response.data.access_token);
        }
      } catch (e) {
        console.log('Unable to generate promotion token');
      }
    }
  }
};
</script>
